module.exports = __webpack_public_path__ + "img/jolly-logo.43060dd0.jpg";